export const deletionRequestsCz = {
  // Direct translations for deletion types and statuses
  USER_ACCOUNT: 'Uživatelský účet',
  TENANT_COMPANY: 'Společnost',

  // Status translations
  PENDING: 'Čeká se',
  PROCESSING: 'Zpracovává se',
  COMPLETED: 'Dokončeno',
  FAILED: 'Neúspěšné',

  // Common translations
  common: {
    cancel: 'Zrušit'
  },

  // Pages structure for settings
  pages: {
    settings: {
      deletionRequests: {
        title: 'Smazání účtu',
        description: 'Spravujte žádosti o smazání účtu a seznamte se s naší politikou uchovávání dat. Všechny žádosti o smazání mají 30denní zpracování, během kterého můžete žádost zrušit.',
        deleteAccount: {
          title: 'Smazat účet',
          description: 'Odeslat žádost o smazání vašeho účtu a všech souvisejících dat po 30denmím zpracování.',
          warning: 'Po odeslání začne 30denní zpracování před smazáním jakýchkoli dat. Žádost můžete zrušit během této doby.',
          activeRequestWarning: 'Už máte aktivní žádost o smazání účtu. Počkejte, dokud nebude zpracována.',
          button: 'Smazat účet'
        },
        existingRequests: {
          title: 'Vaše žádosti o smazání',
          loading: 'Načítají se žádosti o smazání...',
          empty: 'Nebyly nalezeny žádné žádosti o smazání',
          accountDeletion: 'Žádost o smazání účtu',
          requestedAt: 'Požádáno',
          completedAt: 'Dokončeno',
          type: 'Typ',
          verified: 'Ověřená totožnost',
          yes: 'Ano',
          no: 'Ne',
          cancel: 'Zrušit žádost'
        },
        status: {
          PENDING_VERIFICATION: 'Čeká na ověření',
          VERIFIED: 'Ověřeno',
          IN_PROGRESS: 'Zpracovává se',
          COMPLETED: 'Dokončeno',
          REJECTED: 'Zamítnuto',
          CANCELLED: 'Zrušeno',
          pending: 'Čeká se',
          processing: 'Zpracovává se',
          completed: 'Dokončeno',
          failed: 'Neúspěšné'
        },
        types: {
          user_account: 'Uživatelský účet',
          tenant_company: 'Společnost'
        }
      }
    }
  },

  // Modal translations
  modals: {
    deleteAccount: {
      title: 'Smazat účet',
      warning: 'Tímto odešlete žádost o smazání, která začne 30denní zpracování.',
      irreversible: 'Nic se nesmaže okamžitě. Máte 30 dní na zrušení této žádosti před začátkem mazání dat.',
      processingInfo: {
        title: 'Informace o procesu mazání',
        period: '30denní zpracování začne po odeslání žádosti',
        cancellation: 'Žádost můžete zrušit kdykoli během 30denního období',
        finalDeletion: 'Po 30 dnech budou data trvale smazána'
      },
      dataInfo: {
        title: 'Co se stane s vašimi daty?',
        deletedAfter30Days: 'Data smazána po 30denním zpracování:',
        retainedPseudonymized: 'Data uchovávána (pseudonymizovaná) pro právní požadavky:',
        deletedAfter30DaysItems: {
          personalInfo: 'Jméno, email, telefon, adresa',
          cvAttachments: 'Životopis a přílohy',
          notesRatings: 'Poznámky a hodnocení',
          profileData: 'Data profilu'
        },
        retainedItems: {
          applicationData: 'Data žádostí a pozice',
          auditLogs: 'Auditní záznamy',
          consentRecords: 'Záznamy souhlasů',
          technicalLogs: 'IP adresy a technické záznamy',
          period6months: '6 měsíců',
          period12months: '12 měsíců',
          period24months: '24 měsíců'
        }
      },
      reason: {
        label: 'Důvod smazání (volitelné)',
        placeholder: 'Řekněte nám, proč si mažete účet...',
        hint: 'Pomáhá nám to zlepšit naše služby'
      },
      password: {
        label: 'Potvrďte své heslo',
        placeholder: 'Zadejte své současné heslo',
        hint: 'Potřebné k ověření vaší totožnosti'
      },
      confirmation: {
        instruction: 'Napište \'DELETE\' velkými písmeny pro potvrzení:',
        label: 'Potvrzení',
        valid: 'Potvrzovací text je správný',
        invalid: 'Prosím napište \'DELETE\' přesně jak je ukázáno'
      },
      finalConfirmation: 'Rozumím, že tímto začne 30denní zpracování a žádost mohu zrušit během této doby',
      deleteButton: 'Smazat můj účet'
    },
    deleteCompany: {
      title: 'Smazat společnost',
      warning: 'Tímto odešlete žádost o smazání celé společnosti, která začne 30denní zpracování.',
      irreversible: 'Nic se nesmaže okamžitě. Máte 30 dní na zrušení této žádosti před začátkem mazání dat společnosti.',
      dataInfo: {
        title: 'Co se stane s daty společnosti?',
        deletedAfter30Days: 'Data společnosti smazána po 30denním zpracování:',
        retainedPseudonymized: 'Data uchovávána (pseudonymizovaná) pro právní požadavky:'
      },
      reason: {
        label: 'Důvod smazání společnosti (volitelné)',
        placeholder: 'Řekněte nám, proč mažete společnost...',
        hint: 'Pomáhá nám to zlepšit naše služby'
      },
      password: {
        label: 'Potvrďte své heslo',
        placeholder: 'Zadejte své současné heslo',
        hint: 'Potřebné k ověření vaší totožnosti administrátora'
      },
      confirmation: {
        instruction: 'Napište \'DELETE COMPANY\' velkými písmeny pro potvrzení:',
        label: 'Potvrzení',
        valid: 'Potvrzovací text je správný',
        invalid: 'Prosím napište \'DELETE COMPANY\' přesně jak je ukázáno'
      },
      finalConfirmation: 'Rozumím, že tímto začne 30denní zpracování a žádost mohu zrušit během této doby',
      deleteButton: 'Smazat společnost'
    }
  }
};